import styled, { css } from 'styled-components';
import { FlexCenterAligned, FlexibleDiv } from '../../../../../styled/common';
import { Breakpoints } from '../../../../../styled/constants';
import { Typography } from '../../../../ui/Typography';

export const RoomsFilterContainer = styled(FlexibleDiv)`
  gap: 10px;
  overflow-x: auto;
  width: 100%;
  padding: 0 15px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }
`;

export const RoomsFilterItemText = styled(Typography)<{ $isActive: boolean }>`
  white-space: nowrap;
  transition: all 0.3s ease-in-out;

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.colors.systemColors.blue};
    `};
`;

export const RoomsFilterItem = styled(FlexCenterAligned)`
  padding: 0 15px;
  height: 48px;
  width: max-content;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 100px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      ${RoomsFilterItemText} {
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;
